<template>
    <div class="row" id="sales-input">
        <div class="col-xl-12">
            <div class="panel" id="important_work">
                <div class="customer-page p-3">
                    <!-- Filters -->
                    <el-row :gutter="10" class="filter-section mt-3">
                        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="7">
                            <el-input
                                v-model="form.keyword"
                                clearable
                                @input="debounceQuerySever();"
                                class="responsive-input w-100 mt-2"
                                placeholder="Nhập họ tên, SĐT khách hàng"
                            />
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                            <el-select v-if="[7,6].includes(keyAccount)" @change="querySever(); getCenter()"
                                       v-model="form.area_id" placeholder="Chọn Khu vực" filterable collapse-tags clearable
                                       class="w-100 mt-2">
                                <el-option v-for="item in areas" :key="item.id" :label="item.name" :value="item.id"/>
                            </el-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5" v-if="[5,6,7].includes(keyAccount)">
                            <el-select @change="querySever();"
                                       v-model="form.branch_id" placeholder="Chọn văn phòng" filterable clearable
                                       class="w-100 mt-2">
                                <el-option v-for="item in branches" :key="item.id" :label="item.name_alias || item.name" :value="item.id"/>
                            </el-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="7">
                            <el-select filterable  @change="querySever();" clearable v-model="form.tuition_payment_id" class="w-100 mt-2" placeholder="Hình thức đóng học phí">
                                <el-option v-for="item in tuitionPaymentSelect" :key="item.id" :label="item.name" :value="item.id">
                                    <span style="float: left">{{ item.name }}</span>
                                </el-option>
                            </el-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="7">
                            <el-date-picker
                                ref="resultPicker"
                                v-model="form.date_range"
                                type="daterange"
                                start-placeholder="Ngày bắt đầu"
                                end-placeholder="Ngày kết thúc"
                                :clearable="false"
                                :editable="false"
                                class="invisible-picker mt-2"
                                @change="querySever()"
                            />
                        </el-col>
                    </el-row>
                   <div class="mt-4">
                       <h3>Tổng tiền công nợ: {{totalDebt | formatVND}}</h3>

                   </div>

                    <div class="table-responsive-lg b-table-sticky-column table-responsive mt-6 sticky-y">
                        <table class="table table-hover table-striped table-bordered table-customer table-sticky">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th v-for="col in visibleColumns" :key="col.key" :style="col.style">{{ col.label }}</th>
                            </tr>
                            </thead>

                            <tbody v-if="tableData && tableData.length">
                            <tr v-for="(item, key) in tableData" :key="item.id || key">
                                <td>{{ 25 * (paging.current_page - 1) + key + 1 }}</td>
                                <td v-for="col in visibleColumns" :key="col.key">
                                    <template v-if="col.key === 'hanh_dong'">
                                        <el-row class="action-table" style="text-align:center">
                                            <router-link
                                                :to="{ name: 'contract-show-edutalk-v2', params: { contract_id: item.id }, query: { customer_id: item.customer_id } }"
                                                title="Xem" class="btn btn-outline-success btn-icon mr-2 btn-outline-info">
                                                <i class="el-icon-view"></i>
                                            </router-link>
                                            <button
                                                size="medium"
                                                @click="handleDialogDebt(item.id, item.input_debt, item.input_deadline_payment)"
                                                class="btn btn-outline-primary btn-icon mr-2 btn-outline-primary">
                                                <i class="el-icon-bank-card"></i>
                                            </button>
                                        </el-row>
                                    </template>
                                    <template v-else-if="col.key === 'total_after_voucher'">
                                            {{item.total_after_voucher.toLocaleString('vi-VN') }}
                                    </template>

                                    <template v-else-if="col.key === 'total_paid'">
                                        {{item.total_paid.toLocaleString('vi-VN') }}
                                    </template>

                                    <template v-else-if="col.key === 'total_debt'">
                                        {{item.total_debt.toLocaleString('vi-VN') }}
                                    </template>
                                    <template v-else-if="col.key === 'input_debt'">
                                        {{item.input_debt.toLocaleString('vi-VN') }}
                                    </template>

                                    <template v-else>
                                        {{ item[col.key] }}
                                    </template>
                                </td>
                            </tr>
                            </tbody>

                            <tbody v-else>
                            <tr>
                                <td :colspan="14" class="text-center text-muted py-4">
                                    <i class="el-icon-info mr-1"></i> Không có dữ liệu
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <span class="float-right">
                          Tổng bản ghi: <b style="color:#1da7ee">{{ paging.total }}</b>
                        </span>
                    </div>

                    <div class="edutalk-paging">
                        <div class="block">
                            <!--eslint-disable-->
                            <el-pagination
                                background
                                @current-change="handleCurrentChange"
                                :current-page.sync="paging.current_page"
                                :page-size="25"
                                layout="prev, pager, next"
                                :total="paging.total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>

            <el-dialog title="Ghi chú công nợ \ hạn đóng" :visible.sync="dialogDebt" width="30%" @close="resetDebtDialog">
                <div>
                    <div>
                        <span class="mt-2">Số tiền ghi chú còn phải đóng:</span>
                        <el-input
                            v-model="debtInput"
                            type="text"
                            inputmode="numeric"
                            placeholder="Nhập công nợ"
                            class="mt-1"
                            @input="onDebtInput"
                            @blur="onDebtBlur"
                            clearable
                        />
                    </div>

                    <div class="mt-4">
                        <span class="mt-2">Thời hạn đóng tiền:</span>
                        <div class="block">
                            <el-date-picker
                                v-model="input_deadline_payment"
                                type="datetime"
                                class="w-100 mt-1"
                                placeholder="Chọn thời hạn đóng tiền"
                            />
                        </div>
                    </div>

                    <div class="dialog-footer" style="text-align: right; margin-top: 20px;">
                        <el-button @click="resetDebtDialog">Hủy</el-button>
                        <el-button type="primary" @click="submitDebt">Lưu</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { BRANCH_LIST, GET_CHILD_USER } from "@/core/services/store/service.module";
import { GET_REGIONS_BY_USER } from "@/core/services/store/customer/customer.module";
import { mapGetters, mapState } from "vuex";
import {debounce} from "lodash";
import {GET_CONTRACT_BY_SALE, UPDATE_INPUT_DEBT_CONTRACT} from "@/core/services/store/contract/contractOnline.module";
import {tuitionPaymentSelect} from "@/core/config/contract/contractOnlineOption";

export default {
    name: 'important-work',
    components: {  },

    data () {
        return {
            activeTab: 'day',
            form: { branch_id: '', area_id: '', debt_amount: '', keyword: '', tuition_payment_id: '', date_range: '' },
            branches: [], areas: [], options: [], cache_sale: null,
            tableData: [],
            tuitionPaymentSelect: tuitionPaymentSelect,
            paging: {
                current_page: 1,
                per_page: 50,
                total: 0,
            },
            debtInput: '',
            input_deadline_payment: '',
            selectContract: '',
            dialogDebt: false,
            totalDebt: '',
        }
    },

    mounted () {
        this.$store.dispatch(SET_BREADCRUMB, [{ title: "Công nợ", icon: 'far fa-calendar-alt' }])
        this.querySever();this.getCenter(); this.getRegions();
    },

    created() {
        this.debounceQuerySever = debounce(this.querySever, 500);
    },

    methods: {
        querySever () {
            const params = this.form;
            params.page = this.paging.current_page;
            this.$store.dispatch(GET_CONTRACT_BY_SALE, params)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.tableData = response.data.data;
                        this.total = response.data.meta.total;
                        this.paging.current_page = response.data.meta.current_page;
                        this.paging.per_page = response.data.meta.per_page;
                        this.paging.total = response.data.meta.total;
                        this.totalDebt = response.data.summary.totalDebt;
                    }
                    this.loading = false;
                }).finally(() => {
            })
        },
        getCenter () {
            this.$store.dispatch(BRANCH_LIST, { area_id: this.form.area_id }).then(res => {
                if (res.status === 422) this.$message({ type: 'warning', message: `${res.message}`, showClose: true })
                else this.branches = res.data
            })
        },
        getRegions () {
            const payload = { all: this.keyAccount === 7 ? 1 : 0 }
            this.$store.dispatch(GET_REGIONS_BY_USER, payload).then(res => {
                if (res.status === 422) this.$message({ type: 'warning', message: `${res.message}`, showClose: true })
                else this.areas = res.data
            })
        },
        handleDialogDebt(contract_id, input_debt, input_deadline_payment) {
            this.selectContract = contract_id;
            const amount = Number(input_debt || 0);
            this.form.debt_amount = amount > 0 ? amount : null;
            this.debtInput = amount ? this.formatThousands(amount) : '';
            this.input_deadline_payment = input_deadline_payment  ?? '';
            this.dialogDebt = true;
        },
        resetDebtDialog() {
            this.dialogDebt = false;
            this.form.debt_amount = null;
            this.debtInput = '';
            this.input_deadline_payment = '';
        },
        onDebtBlur() {
            this.debtInput = this.formatThousands(this.form.debt_amount);
        },
        formatThousands(n) {
            if (n === null || n === undefined || n === '') return '';
            const s = String(n).replace(/\D/g, '');
            return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        },

        onDebtInput(val) {
            const digits = String(val || '').replace(/\D/g, '');
            this.debtInput = this.formatThousands(digits);
            this.form.debt_amount = digits ? Number(digits) : null;
        },

        submitDebt() {
            const cleanedDebtInput = this.debtInput.replace(/\./g, '');
            const payload = {
                input_debt: cleanedDebtInput,
                input_deadline_payment: this.input_deadline_payment,
                contract_id: this.selectContract
            };

            this.$store.dispatch(UPDATE_INPUT_DEBT_CONTRACT, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.handleRowDebt();
                        this.$message({ type: 'warning', message: `${response.message}`, showClose: true });
                    } else {
                        this.$message({
                            type: 'success',
                            message: 'Lưu công nợ thành công',
                            showClose: true
                        });
                        this.resetDebtDialog();
                        this.querySever(); // refresh bảng
                    }
                });
        },
        handleRowDebt() {
            const contractToUpdate = this.tableData.find(contract => contract.id === this.selectContract);
            if (contractToUpdate) {
                contractToUpdate.input_debt = this.debtInput;
                contractToUpdate.input_deadline_payment = this.input_deadline_payment;
            }
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.querySever({page: val});
        },
    },

    computed: {
        ...mapState({ errors: state => state.auth.errors }),
        ...mapGetters(['currentUser', 'keyAccount']),
        visibleColumns() {
            return  [
                {key: 'id', label: 'Mã hợp đồng'},
                {key: 'customer_name', label: 'Họ và tên'},
                {key: 'customer_phone', label: 'Số điện thoại'},
                {key: 'tuition_payment', label: 'Hình thức thanh toán'},
                {key: 'total_after_voucher', label: 'Tổng tiền cần đóng'},
                {key: 'total_paid', label: 'Số tiền đã đóng'},
                {key: 'total_debt', label: 'Công nợ'},
                {key: 'deadline_payment', label: 'Hạn thanh toán'},
                {key: 'ma_nguoi_gt', label: 'Mã/người giới thiệu'},
                {key: 'ma_nguoi_tvv', label: 'Mã/tên tư vấn viên'},
                {key: 'input_debt', label: 'Ghi chú công nợ'},
                {key: 'input_deadline_payment', label: 'Hạn nộp công nợ'},
                {key: 'hanh_dong', label: 'Hành động', style: 'width: 180px'},
            ];
        },
    }
}
</script>

<style scoped>
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
input[type="number"] { -moz-appearance: textfield; }
.sticky-y {
    max-height: 60vh;
    overflow: auto;
}

.table-sticky {
    border-collapse: separate;
    border-spacing: 0;
    table-layout: auto;
}

.table-sticky thead th {
    position: sticky;
    top: 0;
    z-index: 3;
    background: #fff;
    box-shadow: 0 2px 0 rgba(0,0,0,.04);
}

.table-sticky th:first-child,
.table-sticky td:first-child {
    position: sticky;
    left: 0;
    z-index: 2;
    background: #fff;
}
</style>
